import React from "react";
import PropTypes from "prop-types";
import "../css/cards.css";

const QueryOverviewCard = ({ overview }) => {
  if (!overview) return null;
  const metrics = [
    {
      label: "All-time questions",
      value: overview.totalQueries ?? 0,
    },
    {
      label: "Avg per student",
      value:
        overview.avgPerStudent !== undefined ? overview.avgPerStudent : 0,
    },
    {
      label: "Students active today",
      value: overview.activeToday ?? 0,
    },
  ];

  return (
    <div className="chart-card">
      <h3 className="chart-title">Usage Snapshot</h3>
      <p className="chart-description">
        Counts every question and shows how many students have checked in
        today. Use it to gauge momentum at a glance.
      </p>
      <div className="active-students-stats three-up">
        {metrics.map((metric, index) => (
          <div
            key={`metric-${metric.label}`}
            className={`student-stat ${
              index === 0 ? "primary" : index === 1 ? "secondary" : "tertiary"
            }`}
          >
            <span className="stat-number">{metric.value}</span>
            <span className="stat-label">{metric.label}</span>
          </div>
        ))}
      </div>

      <div className="overview-extra">
        <p className="overview-peak">
          Peak hour today: <strong>{overview.peakHour || "N/A"}</strong>
        </p>
      </div>
    </div>
  );
};

QueryOverviewCard.propTypes = {
  overview: PropTypes.shape({
    totalQueries: PropTypes.number,
    avgPerStudent: PropTypes.number,
    activeToday: PropTypes.number,
    peakHour: PropTypes.string,
  }),
};

export default QueryOverviewCard;
